import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppConfiguratorComponent } from '@/core/layout/components/app-configurator.component';
import { Ripple } from 'primeng/ripple';

@Component({
    selector: 'app-access-denied',
    standalone: true,
    imports: [ButtonModule, RouterModule, AppConfiguratorComponent, Ripple],
    template: `
        <div class="fixed w-full h-full top-0 left-0 opacity-70 text-primary bg-primary-contrast">
            <div class="flex items-center justify-center relative">
                <div class="w-full flex justify-end items-start absolute top-0 left-0 z-10"></div>
                <div class="h-screen flex justify-center items-center w-full lg:w-6/12">
                    <div class="z-50 w-6/12 h-6">
                        <span class="text-lg bg-yellow-500 p-1 px-2 rounded-md text-surface-0 dark:text-surface-900">401</span>
                        <h1 class="text-6xl font-light my-12 mx-0 text-yellow-500">Access Denied</h1>
                        <div class="w-28 bg-yellow-500" style="height: 1px; background-color: #9199a9"></div>
                        <p class="mt-12 text-lg text-color">You do not have the necesary permisions. Please contact admins.</p>
                        <button pButton pRipple type="button" [routerLink]="['/']" label="Go To Dashboard" class="mt-20 border-0! bg-yellow-500!"></button>
                    </div>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="absolute bottom-0 w-screen" viewBox="0 0 1440 250">
                    <defs>
                        <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
                            <stop offset="0%" stop-color="var(--yellow-200)" />
                            <stop offset="99.052%" stop-color="var(--yellow-300)" />
                        </linearGradient>
                        <path id="b" d="M0 202c142.333-66.667 249-90 320-70 106.5 30 122 83.5 195 83.5h292c92.642-106.477 190.309-160.81 293-163 102.691-2.19 216.025 47.643 340 149.5v155.5H0V202z" />
                        <filter id="a" width="105.1%" height="124.3%" x="-2.6%" y="-12.8%" filterUnits="objectBoundingBox">
                            <feOffset dy="-2" in="SourceAlpha" result="shadowOffsetOuter1" />
                            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="12" />
                            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
                        </filter>
                        <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="99.142%">
                            <stop offset="0%" stop-color="var(--yellow-300)" />
                            <stop offset="100%" stop-color="var(--yellow-500)" />
                        </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(0 .5)">
                            <use fill="#000" filter="url(#a)" xlink:href="#b" />
                            <use fill="url(#c)" xlink:href="#b" />
                        </g>
                        <path fill="url(#d)" d="M0 107c225.333 61.333 364.333 92 417 92 79 0 194-79.5 293-79.5S914 244 1002 244s156-45 195-68.5c26-15.667 107-74.167 243-175.5v357.5H0V107z" transform="translate(0 .5)" />
                    </g>
                </svg>
            </div>
        </div>
        <app-configurator simple />
    `
})
export class Page401Component {}
